import * as React from "react";

import { UnifiedDriveWorkspace } from "./workspace/UnifiedDriveWorkspace";

export const RootDriveView: React.FC = () => <UnifiedDriveWorkspace initialScope="all" />;
